import { ISortCopy, ISortMenuProps, ISortOption } from '~types/search'
import { SORT_COPY_EQUIVALENT } from './constants'

export const buildOptions = (
  copy: ISortCopy,
  retailerSorts: ISortOption[]
): ISortMenuProps[] => {
  return retailerSorts.map(({ value }) => {
    const key = value.toString()
    const label = copy[SORT_COPY_EQUIVALENT[value] as keyof ISortCopy] || ''

    return {
      value: value.toString(),
      key,
      label,
    }
  })
}
